import React, { ReactNode } from 'react';
import { AxiosError } from 'axios';

import ErrorBoundary from 'components/ErrorBoundary';
import { ErrorState, ErrorStateKind } from 'components/ErrorState';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: AxiosError;
}

class SuspenseErrorBoundary extends ErrorBoundary {
  declare props: Readonly<Props>;

  constructor(props: Props) {
    super(props);
  }

  public state: State = {
    hasError: false,
    error: undefined,
  };

  public static getDerivedStateFromError(error: AxiosError): State {
    return { hasError: true, error };
  }

  public render() {
    if (this.state.hasError) {
      if (this.state.error?.status === 404 && this.props.fallback) {
        return this.props.fallback;
      } else {
        return <ErrorState kind={ErrorStateKind.SomethingWentWrong} />;
      }
    }

    return this.props.children;
  }
}

export default SuspenseErrorBoundary;
